<template>
  <div>
      <h2>退货管理</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>